import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { createDraft } from '@/features/relux/drafts'
import { newDraft } from '@/features/relux/types'

/** Starts a new draft on the device and opens the form. ?quick=1 opens Quick Relux. */
export const Route = createFileRoute('/_app/reluxes/new')({
  validateSearch: (s: Record<string, unknown>): { quick?: boolean } => ({
    quick: s.quick === true || s.quick === '1' || s.quick === 'true' ? true : undefined,
  }),
  component: NewRelux,
})

function NewRelux() {
  const { me } = Route.useRouteContext()
  const { quick } = Route.useSearch()
  const navigate = useNavigate()
  const started = useRef(false)

  useEffect(() => {
    if (started.current || me.impersonating) return
    started.current = true
    const draft = newDraft({ quick: !!quick })
    void createDraft(me.real_user_id, draft).then((id) =>
      navigate({
        to: '/reluxes/draft/$draftId',
        params: { draftId: id },
        search: { step: quick ? 'quick' : 'project' },
        replace: true,
      }),
    )
  }, [me.real_user_id, navigate, quick])

  if (me.impersonating)
    return (
      <p role="alert" className="mx-auto max-w-lg p-6 text-center font-semibold">
        You're viewing the app as {me.display_name}, which is read-only. Stop viewing (the bar at
        the top) to send a Relux as yourself.
      </p>
    )
  return <p className="p-6 text-center text-fg-muted">Starting a new Relux...</p>
}
